import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "../Response/responseSlice";
import { setToast, setLoading, setModal } from "../uiSlice";
import { createIdioma, editIdioma, getIdiomas } from "../../Services/idioma_service";

const initialState = {
    idiomas: [],
    idioma: {
        idIdioma: 0,
        nombre: '',
        estado: 1,
    },
    idiomasSeleccionados: [],
}

export const idiomaSlice = createSlice({
    name: 'idioma',
    initialState,
    reducers: {
        setIdiomas: (state, action) => {
            state.idiomas = action.payload;
        },
        setIdioma: (state, action) => {
            state.idioma = !action.payload ? initialState.idioma : action.payload;
        },
        setIdiomasSeleccionados: (state, action) => {
            state.idiomasSeleccionados = action.payload;
        },
    }
});

export const fetchIdiomas = createAsyncThunk(
    'idioma/fetchIdiomas',
    async (_, { dispatch }) => {
        const idiomaRes = await getIdiomas();
        dispatch(setIdiomas(idiomaRes));
    }
);

export const addIdioma = createAsyncThunk(
    'idioma/create',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const idiomaRes = await createIdioma(data);
        dispatch(setResponse(idiomaRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(fetchIdiomas());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const EditIdioma = createAsyncThunk(
    'idioma/update',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const idiomaRes = await editIdioma(data);
        dispatch(setResponse(idiomaRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(fetchIdiomas());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const { setIdiomas, setIdioma, setIdiomasSeleccionados } = idiomaSlice.actions;
export default idiomaSlice.reducer;